<template>
  <div class="button-toggle">
    <div
      v-for="tab of tabs"
      :key="tab.value"
      class="page-tab"
      :class="{ active: value === tab.value }"
      @click="$emit('input', tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  value: {
    type: String,
    default: ""
  },
  tabs: {
    type: Array as () => { label: string; value: string }[],
    default: () => []
  }
});
</script>

<style scoped lang="scss">
.button-toggle {
  display: flex;
  justify-content: center;
  div.page-tab {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    white-space: nowrap;
    font-size: 1em;
    padding-bottom: 10px;
    &.active {
      box-shadow: 0 -6px 0 -1px #0f3b95 inset;
      box-sizing: border-box;
      font-weight: bold;
    }
  }
}
</style>
